import React from 'react';
import PropTypes from 'prop-types';
import MenuIcon from '../icons/MenuIcon';
import XIcon from '../icons/XIcon';
import { getClassName } from '../../../utils/ui/classes';

const MenuButton = ({ open, onClick }) => (
  <button
    data-testid="hamburgerMenuButton"
    className="inline-flex items-center justify-center p-2 text-gray-400 rounded-md hover:text-white hover:bg-blue-cm-darker focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
    aria-expanded={open}
    onClick={onClick}
  >
    <span className="sr-only">Open Main Menu</span>
    <MenuIcon
      className={getClassName('w-6', 'h-6', {
        block: !open,
        hidden: open,
      })}
    />
    <XIcon
      className={getClassName('w-6', 'h-6', {
        block: open,
        hidden: !open,
      })}
    />
  </button>
);

MenuButton.propTypes = {
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

export default MenuButton;
